export const SET_TOKEN = 'SET_TOKEN';
export const SET_USER_INFO = 'SET_USER_INFO';

export const SET_NAME = 'SET_NAME';
export const SET_PHONE = 'SET_PHONE';
export const SET_PASSWORD = 'SET_PASSWORD';
export const SET_ORGID = 'SET_ORGID';
export const SET_ORGNAME = 'SET_ORGNAME';
